import {ProtocolTypeEnum} from "../../enums/registry/ProtocolTypeEnum";
import {AcquisitionCronFrequencyEnum} from "../../enums/registry/AcquisitionCronFrequencyEnum";
import {Manufacturer} from "../manufacturer/Manufacturer";
import {Wm2eOriginDTO} from "../../ope/gateway-pending-config/GatewayPendingConfigPayloadDTO";

export class DeviceDraft {
  id?: number;
  partitionId?: number;
  name!: string;
  online?: boolean;
  typeId!: number;
  gatewayId?: number;
  transportConfiguration?: any;
  acquisitionCron: AcquisitionCronFrequencyEnum = AcquisitionCronFrequencyEnum.M1;

  // Overrides
  modelName?: string;
  partNumber?: string;
  protocolType?: ProtocolTypeEnum;
  manufacturerId?: number;
  manufacturer?: Manufacturer;
  modbusWritePauseMillis?: number;

  // Independent of the pending-config draft flow: unlike the other override fields above,
  // writing this is applied immediately server-side regardless of the device's
  // DRAFTED/CREATED state or whether the draft is ever confirmed/sent to the gateway.
  // Null on creation. If null when saving, the backend leaves the current value untouched.
  defaultType?: number;

  metricGroupInstances: MetricGroupInstanceDraft[] = [];
}

export class MetricGroupInstanceDraft {
  id?: number;
  metricGroupId!: number;
  name?: string;
  metricOffset?: number;
  transportConfiguration?: any;
  metrics: MetricInstanceDraft[] = [];
  isWritableOnEdge: boolean = false;

  // FE ONLY - stable grid identity for rows created client-side, before the backend
  // assigns a real `id` on save. See src/app/utils/rowKey.ts.
  _uiKey?: string;
}

export class MetricInstanceDraft {
  id?: number;
  metricId!: number;
  selected!: boolean;
  name?: string;
  divider?: number;
  decimalDigits?: number;
  transportConfiguration?: any;
  dataUnitId?: number;
  wm2eOriginType?: string;
  wm2eOriginId?: number;
  wm2eOrigin?: Wm2eOriginDTO;

  // FE ONLY
  showInvalidBadge?: boolean;
  // FE ONLY - stable grid identity for rows created client-side, before the backend
  // assigns a real `id` on save. See src/app/utils/rowKey.ts.
  _uiKey?: string;
}
